import {Typography} from "@mui/material";

export const ProfileInfoContent = () => {


    return {
        title: 'Profiles',
        content: (
            <>
                <Typography paragraph>
                    Profiles represent the people, companies, and other
                    entities that participate in contractual relationships
                    within the system.
                </Typography>

                <ul>
                    <li>
                        Profiles may represent individuals such as actors,
                        writers, directors, musicians, producers, or other
                        stakeholders.
                    </li>

                    <li>
                        Profiles may also represent companies such as
                        production companies, distributors, agencies,
                        payroll providers, guilds, or other business
                        entities.
                    </li>

                    <li>
                        Profiles are commonly referenced by contracts,
                        financial records, obligations, payments, and
                        other operational data throughout the system.
                    </li>

                    <li>
                        A Profile may contain identifying information such
                        as names, company information, tax identifiers,
                        dates of birth, dates of death, payment status,
                        and other administrative details.
                    </li>

                    <li>
                        Maintaining accurate Profile information helps
                        ensure that obligations, payments, and reporting
                        are associated with the correct individuals and
                        organizations.
                    </li>

                    <li>
                        Use the <strong>Search</strong> (magnifying glass)
                        to locate existing Profile records.
                    </li>

                    <li>
                        Use the <strong>Upload</strong> button to import
                        Profile data from external files.
                    </li>

                    <li>
                        Use the <strong>Add</strong> (+) button to create
                        a new Profile manually.
                    </li>

                    <li>
                        Use the row menu on the left side of the grid
                        to clone, edit, or delete Profile records.
                    </li>

                    <li>
                        Accurate Profile data is essential because Profiles
                        serve as the primary parties to contracts and are
                        frequently referenced throughout the calculation,
                        payment, and reporting processes.
                    </li>
                </ul>
            </>
        )
    };

};






